import { TourConfig, TourHandle, useFeatureTour } from '@app/core/tours/useFeatureTour';
import { useMemo } from 'react';
import { defineMessage, useIntl } from 'react-intl';

/**
 * Runs the one-time tour for the fragments grid view toggle (list/grid switch) if not yet seen and before expiry.
 */
export function useFragmentGridViewToggleTour(): TourHandle {
  const { $t } = useIntl();

  return useFeatureTour(
    { key: 'fragmentGridViewToggle', expiry: '2026-03-22' },
    useMemo<TourConfig>(
      () => ({
        steps: [
          {
            element: '#fragment-grid-view-toggle',
            popover: {
              title: $t(
                defineMessage({
                  id: 'fragments.listV3.tour.viewToggle.title',
                  defaultMessage: 'Vista de fragmentos',
                }),
              ),
              description: $t(
                defineMessage({
                  id: 'fragments.listV3.tour.viewToggle.description',
                  defaultMessage:
                    'Cambia entre lista y grilla (amplia, normal o compacta) para ver los fragmentos como prefieras.',
                }),
              ),
              side: 'left',
              align: 'start',
            },
          },
        ],
      }),
      [$t],
    ),
  );
}
